var map = {
	"./001.gif": 834,
	"./002.gif": 835,
	"./003.gif": 836,
	"./004.gif": 837,
	"./005.gif": 838,
	"./006.gif": 839
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 833;


//////////////////
// WEBPACK FOOTER
// ./src/images/totoro ^\.\/00.*\.gif$
// module id = 833
// module chunks = 0